<div
  class="z-[999] fixed inset-0 bg-black/50 backdrop-blur-xs flex items-center justify-center"
>
  <div class="bg-white rounded-2xl min-w-[600px] max-w-full flex flex-col mx-auto">
    <div class="flex items-center justify-between px-6">
      <h1 class="m-4 text-dimot-1 text-[1.5em]">
          Esperienze per Ospedale - {{
    regionName === 'Prov. Aut. di Bolzano' ? 'PA di Bolzano' :
    regionName === 'Prov. Aut. di Trento' ? 'PA di Trento' :
    regionName
  }}
      </h1>
      <button>
        <svg
          (click)="oncloseModal(false)"
          class="mr-[7px] cursor-pointer"
          width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M19.1471 18.3525C19.2024 18.404 19.2467 18.4661 19.2775 18.5351C19.3082 18.6041 19.3248 18.6786 19.3261 18.7541C19.3274 18.8296 19.3135 18.9047 19.2852 18.9747C19.2569 19.0447 19.2148 19.1084 19.1614 19.1618C19.108 19.2152 19.0444 19.2573 18.9743 19.2856C18.9043 19.3139 18.8293 19.3278 18.7537 19.3265C18.6782 19.3251 18.6037 19.3086 18.5347 19.2778C18.4657 19.2471 18.4036 19.2028 18.3521 19.1475L11.9996 12.7959L5.64714 19.1475C5.54051 19.2469 5.39947 19.301 5.25375 19.2984C5.10802 19.2958 4.96898 19.2368 4.86592 19.1337C4.76286 19.0307 4.70383 18.8916 4.70126 18.7459C4.69869 18.6002 4.75278 18.4591 4.85214 18.3525L11.2037 12L4.85214 5.64751C4.75278 5.54088 4.69869 5.39984 4.70126 5.25411C4.70383 5.10839 4.76286 4.96935 4.86592 4.86629C4.96898 4.76323 5.10802 4.7042 5.25375 4.70163C5.39947 4.69905 5.54051 4.75315 5.64714 4.85251L11.9996 11.2041L18.3521 4.85251C18.4588 4.75315 18.5998 4.69905 18.7455 4.70163C18.8913 4.7042 19.0303 4.76323 19.1334 4.86629C19.2364 4.96935 19.2955 5.10839 19.298 5.25411C19.3006 5.39984 19.2465 5.54088 19.1471 5.64751L12.7956 12L19.1471 18.3525Z" fill="#141F58"/>
        </svg>
      </button>
    </div>
    
    <div class="border-1 w-full h-[1px] border-[#E5E7EB]"></div>
    
    <!-- main container -->
    <div class="w-full flex flex-col items-center justify-center"
         [ngStyle]="{'height': getHeight()}">

      <div *ngIf="isLoading" class="flex justify-center items-center h-full w-full relative top-30">
        <div
          class="w-16 h-16 border-[6px] border-t-transparent border-gray-600 rounded-full animate-spin"
        ></div>
      </div>

      <div
        *ngIf="isDataEmpty"
        class="flex items-center justify-center h-full min-h-[300px] w-full"
      >
        <div class="text-center flex flex-col items-center">
          <i class="fa-solid fa-file-excel text-4xl text-gray-400 mb-4"></i>
          <span class="text-lg text-gray-600 font-medium">
            Nessun Dato Trovato
          </span>
        </div>
      </div>

      <div
        *ngIf="!isDataEmpty"
        class="flex flex-row h-full gap-6 items-center justify-center w-full px-6 pb-6"
      >
        <!-- pie -->
        <div class="w-4/10 h-full flex items-center justify-center p-4"> 
          <div class="w-[220px] h-[220px] flex-shrink-0">
            <canvas id="myPieChart" class="w-full h-full"></canvas>
          </div>
        </div>

        <!-- hospitals -->
    <div id="pieChartLabels"
     class="w-full h-full text-[0.9rem] text-black py-4 pl-4 pr-6 flex flex-col justify-center items-start
           scrollbar overflow-y-auto"
           [ngClass]="{'flex flex-col justify-center items-start': labelsData!.length < 10}"
           >
</div>
      </div>
    </div>
  </div>
</div>